export function shuffleArray(arr:{ port: string; rus: string; }[]) {
  const result = [...arr]; // копия, исходный массив не трогаем

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
}
